import AppRestService from './app-rest.service';
import ScheduleModel from '../models/schedule.model';



/**
 * Service Endpoint Implementation
 */
export default class SchedulesService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'schedules';
    this.routePath = 'schedules';
    this.idParamName = 'schedule_id';
    this.modelClass = ScheduleModel;
    this.authEnabled = true;
  }

}

